import {spaceNumber} from "../../../utils/numerals/spaceNumber";

export const initCalculatorMortgage = () => {
	const components = Array.from(document.querySelectorAll( 'section.calculator-mortgage' ));
	
	if ( components.length )
	{
		components.forEach( ( component ) => {
			
			const container = component.querySelector( 'div.container' );
			const banks = container.querySelector( 'div.banks' );
			const form = container.querySelector( 'form' );
			const percent_span = form.querySelector( 'span.percent' );
			const price_label = form.querySelector( 'label[for="price"]' );
			const price_input = form.querySelector( 'input[name="price"]' );
			const install_input = form.querySelector( 'input[name="install-payment"]' );
			const months_input = form.querySelector( 'input[name="payment-time"]' );
			const programs = Array.from(container.querySelectorAll( 'ul.banks > li.program' ));
			const zero_state = container.querySelector( 'li.zero-state' );
			const price_min = parseInt( price_input.getAttribute( 'data-min' ));
			const price_max = parseInt( price_input.getAttribute( 'data-max' ));

			component.classList.contains( 'apartment' ) ? price_input.setAttribute( 'disabled', '' ) : price_input.removeAttribute( 'disabled', '' );

			if ( component.classList.contains( 'apartment' ) && !document.querySelector( 'div.price' ).querySelector( 'strong' ).hasAttribute( 'data-main' ))
			{
				component.style.display = 'none';

				return
			}

			const checkType = () => {

				const type = location.href.split( '/' )[5];

				switch( type )  {
					case 'parking': price_label.textContent = 'Стоимость машиноместа';
					break;
					case 'storage': price_label.textContent = 'Стоимость кладовой';
					break;
					case 'commercial': price_label.textContent = 'Стоимость помещения';
					break;
					default: price_label.textContent = 'Стоимость квартиры';
				}

				if ( location.href.split( '/' )[3] === 'commercial' )
				{
					price_label.textContent = 'Стоимость помещения';
				}
			}
		
			const setExtremes = () => {

				const init_price = parseInt( price_input.value.replace(/[^0-9]+/g, ''));
				const install_payments_min = [];
				const install_payments_max = [];
				const payment_times_min = [];
				const payment_times_max = [];
				const default_payment_time = 360;
				const default_install_payment = init_price / 100 * 90;

				if ( parseInt( price_input.getAttribute( 'min' )) === parseInt( price_input.getAttribute( 'max' )))
				{
					price_input.setAttribute( 'disabled', '' );
					price_input.closest( 'div.range-one' ).querySelector( 'div.controls' ).style.display = 'none'; 
				}  

				// console.log(parseInt( price_input.getAttribute( 'min' )) == parseInt( price_input.getAttribute( 'max' )))

				programs.forEach( ( program ) => {

					const json = JSON.parse( program.querySelector( 'li.bank' ).getAttribute( 'data-json' ));

					let install_payment_min = parseInt( json.install_payment_min );
					let install_payment_max = !install_payment_max ? default_install_payment : parseInt( json.install_payment_max );

					let payment_time_min = parseInt( json.payment_time_min );
					let payment_time_max = !payment_time_max ? default_payment_time : parseInt( json.payment_time_max );

					install_payments_min.push( install_payment_min );
					install_payments_max.push( install_payment_max );
					payment_times_min.push( payment_time_min );
					payment_times_max.push( payment_time_max );
				});

				install_input.setAttribute( 'min', ( init_price / 100 * Math.min.apply( null, install_payments_min )));
				install_input.setAttribute( 'max', Math.max.apply( null, install_payments_max ));

				if ( isNaN(Math.min.apply( null, payment_times_min )))
				{
					months_input.setAttribute( 'min', 0 );
				}
				else
				{
					months_input.setAttribute( 'min', Math.min.apply( null, payment_times_min ));
				}
				months_input.setAttribute( 'max', Math.max.apply( null, payment_times_max ));
			}

			const checkValids = () => {
				const validNodes = [...component.querySelectorAll( 'li.program.valid' )];

				if ( validNodes.length > 0 )
				{
					zero_state.classList.add( 'hidden' );
					banks.classList.remove( 'zero' );
				}
				else
				{
					zero_state.classList.remove( 'hidden' );
					banks.classList.add( 'zero' );
				} 
			}

			const updatePercent = () => {
				let price = price_input.value;
				let install_payment = install_input.value;
				price = typeof price === 'string' ? price.replace(/[^0-9]+/g, '') : price;
				install_payment = typeof install_payment === 'string' ? install_payment.replace(/[^0-9]+/g, '') : install_payment;
				const value = Math.round(( install_payment / price ) * 100 );
				!isFinite(value) ? percent_span.textContent = 0 : ( value > 100 ) ? percent_span.textContent = 100 : percent_span.textContent = value;				
			}
			
			const updatePrice = () => {
				let value = parseInt( price_input.value.replace(/[^0-9]+/g, ''));
				value = isNaN( value ) ? 0 : value;	
				price_input.value = `${spaceNumber( value )} ₽`;
				setExtremes();
			}

			const updateInstallPayment = () => install_input.value = `${spaceNumber( parseInt( install_input.value.replace(/[^0-9]+/g, '')))} ₽`;

			const recount = () => {

				let price = parseInt( price_input.value.replace(/[^0-9]+/g, '')); 
				const install_payment = parseInt( install_input.value.replace(/[^0-9]+/g, '')) + 1; // для корректного расчета ( магия js )
				const months = parseInt( months_input.getAttribute( 'data-value' ));

				price = price < price_min ? price_min : price > price_max ? price_max : price

				programs.forEach( ( program ) => {

					const json = JSON.parse( program.querySelector( 'li.bank' ).getAttribute( 'data-json' ));
	
					let valid_prog = null;
	
					let valid_programs = [];
					
					let debt = price - install_payment;
					let time = months;	

					for ( let j in json )
					{
						if ( json.hasOwnProperty(j) )
						{
							let cp_full_price_min = parseInt( json.full_price_min );
							let cp_full_price_max = parseInt( json.full_price_max );
							cp_full_price_max = !cp_full_price_max ? Infinity : cp_full_price_max;

							let cp_time_min = parseInt( json.payment_time_min );
							let cp_time_max = parseInt( json.peyment_time_max );
							cp_time_max = !cp_time_max ? Infinity : cp_time_max;

							let cp_install_payment_min = parseInt( json.install_payment_min );
							let cp_install_payment_max = parseInt( json.install_payment_max );
							cp_install_payment_max = !cp_install_payment_max ? Infinity : cp_install_payment_max;

							if (
								( debt >= cp_full_price_min && debt <= cp_full_price_max )
								&& 
								( time >= cp_time_min && time <= cp_time_max )
								&& 
								( install_payment >= price / 100 * cp_install_payment_min && install_payment <= price / 100 * cp_install_payment_max )
							)
							{
								valid_programs.push( json );
							}
						}
					}

					if ( valid_programs.length == 0 )
					{
						program.classList.add( 'invalid' );
						program.classList.remove( 'valid' );
					} 
					else
					{
						program.classList.remove( 'invalid' );
						program.classList.add( 'valid' );
						
						if ( valid_programs.length == 1 )
						{
							valid_prog = valid_programs[0];
						}
						else
						{
							for ( let k in valid_programs )
							{
								if ( valid_programs.hasOwnProperty(k) )
								{
									if ( valid_prog == null )
									{
										valid_prog = json;
									}
									else
									{
										if ( json.rate < valid_prog.rate )
										{
											valid_prog = json;
										}
									}
								}
							}
						}
					}

					if ( valid_prog == null )
					{
						return
					}
					else
					{
						let monthly_percent = parseFloat( valid_prog.rate.replace( ',', '.' )) / 100 / 12;						
						let monthly_payment = debt * ( monthly_percent + ( monthly_percent / ( Math.pow( 1 + monthly_percent, time ) - 1 )));
	
						program.querySelector( 'li.payment > span.payment' ).textContent = spaceNumber( parseInt( monthly_payment ));
						program.querySelector( 'li.rate > span.rate' ).textContent = valid_prog.rate;
					}					

					setExtremes();
				});

				checkValids();
			}


			const getMinPayment = () => {

				const price_divs = document.querySelectorAll( 'div.price' );
				
				if ( price_divs.length && price_divs[0].querySelector( 'ul' ) )
				{
					const valids = component.querySelectorAll( 'li.program.valid' );

					let valid_payments = [];
					
					if ( valids.length )
					{
						valids.forEach( ( valid ) => {
							let payment = valid.querySelector( 'span.payment' ).textContent;
							payment = payment.replace(/\s/g, '' );
							valid_payments.push( payment );
						});	

						valid_payments.sort();

						// return valid_payments[0];
						const priceChilds = Array.from(document.querySelectorAll('.price>ul>li.price--mortgage'));
						const mortgage_price = document.createElement( 'li' );
						mortgage_price.classList.add( 'price--mortgage' );
						priceChilds.forEach( priceElement => {
							if (priceChilds.length >= 1 && priceElement.classList.contains( 'last--price' ))
							{
								price_divs[0].querySelector( 'ul' ).removeChild( priceChilds[0] );
								priceElement.classList.remove( 'last--price' );
							}
						});
						if (priceChilds.length >= 1)
							{
								mortgage_price.classList.add( 'last--price' );
							}
						mortgage_price.textContent = `ипотека от\u00A0${spaceNumber( valid_payments[0] )}\u00A0₽/мес`;
						price_divs[0].querySelector( 'ul' ).appendChild( mortgage_price );
					}
				}
			}

			recount();
			updatePercent();
			updatePrice();
			updateInstallPayment();
			getMinPayment();
			checkType();

			months_input.addEventListener( 'change', () => {
				setTimeout( () => {
					recount();
					getMinPayment();
				}, 400 );
			});

			install_input.addEventListener( 'change', () => {
				setTimeout( () => {
					updateInstallPayment();
				}, 3000 );

				setTimeout( () => {
					updatePercent();
					recount();
					getMinPayment();
				}, 400 );
			});

			install_input.addEventListener( 'keyup', () => {
				setTimeout( () => {
					updateInstallPayment();
				}, 3000 );

				setTimeout( () => {
					updatePercent();
					recount();
					getMinPayment();
				}, 400 );
			});

			price_input.addEventListener( 'change', () => {
				if ( component.classList.contains( 'apartment' ))
				{
					updatePrice();
					updatePercent();
				}
				else
				{
					setTimeout( () => {
						updatePrice();
						updatePercent();
					}, 3000 );
				}
					
				setTimeout( () => {
					recount();
					getMinPayment();
				}, 400 );
			});

			price_input.addEventListener( 'keyup', () => {
				setTimeout( () => {
					updatePrice();
					updatePercent();
				}, 3000 );

				setTimeout( () => {
					recount();
					getMinPayment();
				}, 400 );
			});
		});
	}
}
